import React from 'react'
import Layout from '../../components/Layout'

const ProfilePage = () => {
    return (
        <React.Fragment>
            Profile Page
        </React.Fragment>
    )
}

export default ProfilePage
